import React from 'react';
import GamesView from './Games.view';
import { useGetUserInformationQuery } from '../../store/api/GraphQlQuery';
import { usePermissions } from '../../context/PermissionsContext/PermissionsContext';
import { PermissionKeys } from '../../context/PermissionsContext/permissionTypes';

const GamesContainer = () => {
  const { data, isLoading: isLoadingGetUserInformation } =
    useGetUserInformationQuery({});
  const { checkPermission } = usePermissions();
  const showAdd = Boolean(
    !isLoadingGetUserInformation &&
      data &&
      checkPermission(PermissionKeys.GamesRewards_CreateGame)
  );

  console.log('SHOW ADD: ', showAdd);

  return <GamesView showAdd={showAdd} />;
};

export default GamesContainer;
